(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/views/result-page.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/views/result-page.js');

'use strict';

svs.keno.views.ResultPage = Marionette.View.extend({
  viewOptions: ['dateString'],
  dateString: undefined,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'keno',
    component: 'result'
  }],
  regions: {
    resultRegion: '#ngResultRegion'
  },
  template() {
    return svs.keno.templates.result_page();
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.keno.components.result) {
      this.showChildView('resultRegion', new svs.keno.components.result.views.Result({
        selectedDate: this.dateString
      }));
    }
  }
});

 })(window);